export default __webpack_public_path__ + "locales/sk/EmptyTrashDialog.json?hash=78c0d0a83a1f761467669d42300ccc9b";